import Images from '../../common/Images'

interface Experiment {
  title: string
  link: string
}

export interface ExperimentSection {
  title: string
  experiments: Experiment[]
}

const AllExperiments: ExperimentSection[] = [
  {
    title: 'Medium and reagents',
    experiments: [
      {
        title: 'Solutions for agarose gels',
        link: Images.ExperimentsAgarose
      },
      {
        title: 'Solutions for SDS-PAGE gels',
        link: Images.ExperimentsSdsPage
      },
      {
        title: 'Solutions for competent cells',
        link: Images.ExperimentsSolutionsCompetentCells
      },
      {
        title: 'Solutions for DNA extraction',
        link: Images.ExperimentsDnaExtraction
      }
    ]
  },
  {
    title: 'Antibiotics',
    experiments: []
  },
  {
    title: 'Gene and plasmid construction and verification',
    experiments: [
      {
        title: 'Colony PCR (for bacteria)',
        link: Images.ExperimentsColonyPCR
      },
      {
        title: 'Quick DNA extraction',
        link: Images.ExperimentsQuickDnaExtraction
      }
    ]
  },
  {
    title: 'Cloning in E. coli',
    experiments: [
      {
        title: 'Competent bacteria cells preparation',
        link: Images.ExperimentsCompetentCells
      },
      {
        title: 'Restriction-ligation cloning',
        link: Images.ExperimentsRestrictionLigationCloning
      },
      {
        title: 'Competent bacteria cells transformation ',
        link: Images.ExperimentsTransformationHeat
      }
    ]
  },
  {
    title: 'Protein expression',
    experiments: [
      {
        title: 'Protein expression',
        link: Images.ExperimentsProteinExpression
      }
    ]
  },
  {
    title: 'Protein purification',
    experiments: [
      {
        title: 'Protein purification and SDS-PAGE',
        link: Images.ExperimentsProteinPurification
      },
      {
        title: 'Buffer Exchange and Protein Concentration',
        link: Images.ExperimentsBufferExchange
      }
    ]
  }
]

export default AllExperiments
